/* Copyright (c) Trimble Inc. All rights reserved. */
import ProductDiscovery from "pages/home/products/pages/ProductDiscovery";
import React from "react";
import { useGlobalProductListController } from "pages/guest/controller/GlobalProductListController";
import { Box } from "@material-ui/core";
import { Breadcrumbs } from "modus/components/generic-page-title/Breadcrumbs";



export const GuestProduct:React.FC = () => {
    const {asyncResponse} =  useGlobalProductListController();
   
    return (
      <Box m={2}>
        <Breadcrumbs
            links={[{text: "Home", href:"/guest/home/"}]}
            pageTitle={"Products"} 
            addHome={false}
        />
        <ProductDiscovery asyncResponse={asyncResponse} isGuest={true}/>
      </Box>
    )
};

export default GuestProduct;
